import { gql } from "@apollo/client";

export const CREATE_TICKET = gql`
  mutation CreateTicket($input: CreateTicketInput!) {
    createTicket(input: $input) {
      id
      ticketNumber
      subject
      description
      status
      priority
      createdBy {
        id
        name
      }
      assignedTo {
        id
        name
      }
      createdAt
    }
  }
`;

export const UPDATE_TICKET = gql`
  mutation UpdateTicket($input: UpdateTicketInput!) {
    updateTicket(input: $input) {
      id
      ticketNumber
      subject
      status
      priority
      assignedTo {
        id
        name
        email
        avatar
      }
      updatedAt
    }
  }
`;

export const TRANSFER_TICKET = gql`
  mutation TransferTicket($ticketId: ID!, $newAssignee: ID!) {
    transferTicket(ticketId: $ticketId, newAssignee: $newAssignee) {
      id
      ticketNumber
      assignedTo {
        id
        name
        email
        avatar
      }
      history {
        id
        action
        performedByName
        timestamp
        oldValue
        newValue
        details
      }
      updatedAt
    }
  }
`;

export const ADD_TICKET_MESSAGE = gql`
  mutation AddTicketMessage($input: AddTicketMessageInput!) {
    addTicketMessage(input: $input) {
      id
      ticketNumber
      messages {
        id
        sender {
          id
          name
          email
          avatar
        }
        senderName
        content
        timestamp
        isInternal
      }
      history {
        id
        action
        performedByName
        timestamp
        details
      }
      updatedAt
    }
  }
`;

export const CLOSE_TICKET = gql`
  mutation CloseTicket($ticketId: ID!, $resolution: String) {
    closeTicket(ticketId: $ticketId, resolution: $resolution) {
      id
      ticketNumber
      status
      history {
        id
        action
        performedByName
        timestamp
        oldValue
        newValue
        details
      }
      updatedAt
    }
  }
`;

export const DELETE_TICKETS = gql`
  mutation DeleteTickets($ticketIds: [ID!]!) {
    deleteTickets(ticketIds: $ticketIds) {
      success
      deletedCount
    }
  }
`;
